import {
  DelegateEditDate, DelegationEditDataDate,
  DelegationsDataInProgress, DelegationsDataInProgressFromBack, NewDelegation
} from '@/interfaces/delegate/delegateInterfaces';
import { Person } from '@/interfaces/person';
import { parseISOString } from '@/utils/parseISOString';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '@/auth/service/auth.service';
import { CacheService } from '@/utils/cacheService/cache.service';

@Injectable({
  providedIn: 'root',
})
export class DelegateService {
  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private cacheService: CacheService,
  ) { }

  createDelegation(args: NewDelegation) {
    const assignedRol = this.auth.getRoles()[0].name;

    const { requestorId, requestorToDelegateId, ...otherKeys } = args;
    const newContract = { ...otherKeys, assignedRol, assigned: requestorId, assignedToDelegate: requestorToDelegateId };
    this.cacheService.remove('getRequestApprovalPending');
    return this.http.post('Delegation/Create', newContract)
      .pipe(take(1));
  }

  getDelegations(rut: string): Observable<DelegationsDataInProgress[]> {
    return this.http.get<DelegationsDataInProgressFromBack[]>('Delegation/InProgressByQuery', { params: { delegatingRut: rut } })
      .pipe(map((delegations) => delegations.map((delegation) => {
        const dateStartAsDate = parseISOString(delegation.dateStart);
        let dateEndAsDate;
        try {
          dateEndAsDate = parseISOString(delegation.dateEnd);
        }
        // eslint-disable-next-line no-empty
        catch { }
        return { ...delegation, dateEnd: dateEndAsDate, dateStart: dateStartAsDate };
      })));
  }

  editDelegation(dataForm: DelegateEditDate): Observable<DelegationEditDataDate[]> {
    const assignedRol = this.auth.getRoles()[0].name;

    const { requestorId, ...otherKeys } = dataForm;
    const newContract = { ...otherKeys, assignedRol, assigned: requestorId };
    this.cacheService.remove('getRequestApprovalPending');
    return this.http.post<DelegationEditDataDate[]>('Delegation/UpdateDelegateDate', newContract)
      .pipe(take(1));
  }

  deleteDelegation(dataForm: DelegateEditDate): Observable<DelegationEditDataDate[]> {
    const { requestorId, ...otherKeys } = dataForm;
    const newContract = { ...otherKeys, assigned: requestorId };
    this.cacheService.remove('getRequestApprovalPending');
    return this.http.post<DelegationEditDataDate[]>('Delegation/Delete', newContract);
  }
}
